
export function addDays (date: Date, days: number): Date {
  const excludedToDate = new Date(date)
  const includedToDate = new Date(Date.UTC(excludedToDate.getFullYear(), excludedToDate.getMonth(), excludedToDate.getDate() + days))
  return includedToDate
}

export function substractDays (date: Date, days: number): Date {
  const includedToDate = new Date(date)
  const excludedToDate = new Date(Date.UTC(includedToDate.getFullYear(), includedToDate.getMonth(), includedToDate.getDate() - days))
  return excludedToDate
}

export function createUtcIsoDate (date: Date): string {
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0, 0))
  return d.toISOString()
}
